var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('CSpinner',{style:(_vm.getSize(_vm.size)),attrs:{"color":"custom-color"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }